import { Divider, useTheme } from "@mui/material";
import * as React from "react";

export const RobotoDivider: React.FC<React.ComponentProps<typeof Divider>> = (
  props,
) => {
  const theme = useTheme();
  return (
    <Divider
      className={props.className}
      sx={{
        borderColor: theme.border.color,
      }}
    />
  );
};
